<template lang="html">
  <div class="Dashboard">
    <dashboard-top>
      <screen-title title="Settings"></screen-title>
    </dashboard-top>
    <div class="container-full">
      <tabs>
        <tab title="Account & profile details">
          <section class="section">
            <div class="section__col">
              <div class="dashboard__section">
                <section-title title="Profile information" />
                <UpdateProfile />
              </div>
            </div>
            <div class="section__col section__col--bottom">
              <div class="dashboard__section">
                <section-title title="Update password" />
                <ChangePassword />
              </div>
            </div>
          </section>
        </tab>

        <tab title="Club information" v-if="userIs('admin')">
          <section class="section">
            <UpdateTeam></UpdateTeam>
          </section>
        </tab>
        <tab title="Remove Account">
          <RemoveAccount></RemoveAccount>
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import UpdateProfile from '@/components/Forms/UpdateProfile'
  import ChangePassword from '@/components/Forms/ChangePassword'
  import UpdateTeam from '@/components/Forms/UpdateTeam'
  import RemoveAccount from './partials/RemoveAccount'

  export default {
    name: 'ProfileSettings',
    components: {
      UpdateProfile,
      ChangePassword,
      RemoveAccount,
      UpdateTeam,
    },
    computed: {
      ...mapState({
        user: (state) => state.user,
        role: (state) => (state.user ? state.user.role : false),
        team: (state) => (state.user ? state.user.team : false),
      }),
    },
  }
</script>
